module.exports = __webpack_public_path__ + "static/media/female_fairy.d8f9b62d.png";